<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__menu">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:menu:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t('add') }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:dict:delete')"
            type="danger"
            @click="deleteHandle()"
            >{{ $t('deleteBatch') }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%;"
        @selection-change="dataListSelectionChangeHandle"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <!-- <table-tree-column prop="name" :label="$t('menu.name')" header-align="center" width="150"></table-tree-column> -->
        <el-table-column
          prop="name"
          :label="$t('menu.name')"
          header-align="center"
          align="left"
          width="200"
        />
        <el-table-column
          prop="icon"
          :label="$t('menu.icon')"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <svg class="icon-svg" aria-hidden="true">
              <use :xlink:href="`#${scope.row.icon}`" />
            </svg>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('menu.type')"
          header-align="center"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 0" size="small">{{
              $t('menu.type0')
            }}</el-tag>
            <el-tag v-else size="small" type="info">{{
              $t('menu.type1')
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          :label="$t('menu.sort')"
          header-align="center"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="url"
          :label="$t('menu.url')"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="permissions"
          :label="$t('menu.permissions')"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('sys:menu:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t('update') }}</el-button
            >
            <el-button
              v-if="$hasPermission('sys:menu:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import TableTreeColumn from '@/components/table-tree-column'
import AddOrUpdate from './menu-add-or-update'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/menu/list',
        deleteURL: '/sys/menu',
        deleteIsBatch: true,
      },
    }
  },
  components: {
    TableTreeColumn,
    AddOrUpdate,
  },
}
</script>
